var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H13C14.1046 19 15 18.1046 15 17V3C15 1.89543 14.1046 1 13 1Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 3,
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 13,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13,
    r: 1,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 1,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 1,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 16,
    r: 1,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 16,
    r: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default __webpack_public_path__ + "static/media/intercom.c840a15623522da1d83bb62fb0b0daa1.svg";
export { ForwardRef as ReactComponent };